import { BodyText, Button, Flex } from '@utilitywarehouse/hearth-react';
import { FC } from 'react';

import { DialogActions, DialogID, DialogUnsynced } from '@components/Dialog';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { useDetailsContext } from '@providers/basket/DetailsProvider/Context';
import { useResetAppointmentSession } from '@store/appointment/selectors';
import { clearFormPersistStorage } from '@utils/storagePropertyManagement';

interface AppointmentErrorDialogUIProps {
  onReset: () => void;
  onReload: () => void;
}

const AppointmentErrorDialogUI = ({
  onReset,
  onReload,
}: AppointmentErrorDialogUIProps) => (
  <DialogUnsynced
    id={DialogID.APMT_ERROR}
    heading="Something went wrong"
    preventDismiss
    hideCloseButton
  >
    <Flex direction="column" spacing="lg">
      <BodyText>
        But don't worry, it's not your fault. Try reloading the page to fix it.
      </BodyText>
      <BodyText>
        If the problem keeps happening, you can reset your appointment data to
        start fresh. (Note: this will clear your current appointment and
        basket.)
      </BodyText>
    </Flex>
    <DialogActions>
      <Button variant="outline" colorScheme="destructive" onClick={onReset}>
        Clear appointment data
      </Button>
      <Button variant="solid" onClick={onReload}>
        Reload page
      </Button>
    </DialogActions>
  </DialogUnsynced>
);

const AppointmentErrorDialog: FC = () => {
  const resetAppointmentSession = useResetAppointmentSession();
  const { resetDetails } = useDetailsContext();
  const { handleStartAgain } = useBasketContext();

  const reset = () => {
    resetDetails();
    handleStartAgain();
    clearFormPersistStorage();
    resetAppointmentSession();
    location.reload();
  };

  return (
    <AppointmentErrorDialogUI
      onReset={reset}
      onReload={() => location.reload()}
    />
  );
};

export type { AppointmentErrorDialogUIProps };

export { AppointmentErrorDialog, AppointmentErrorDialogUI };
